import { HttpErrorResponse } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { ModalName } from "src/app/enums/modal-name";
import { AuthService } from "src/app/services/auth.service";
import { ModalService } from "src/app/services/modal.service";

const DEFAULT_ERROR_MESSAGE = "Something went wrong, please try again";

@Component({
  selector: "app-restore-password",
  templateUrl: "./restore-password.component.html",
  styleUrls: ["./restore-password.component.scss"],
})
export class RestorePasswordComponent implements OnInit {
  form: UntypedFormGroup;
  isRequestError = false;
  requestErrorMessage = DEFAULT_ERROR_MESSAGE;

  constructor(
    private readonly _authService: AuthService,
    private readonly _modalService: ModalService,
    private readonly _router: Router
  ) {}

  requestPasswordReset() {
    this.isRequestError = false;

    const email: string = this.form.get("email").value;

    this._authService.requestPasswordReset(email).subscribe({
      next: () => this._modalService.openModal(ModalName.Success),
      error: (error: HttpErrorResponse) => this.showRequestError(error),
    });
  }

  navigateToAuth() {
    this._router.navigate(["/auth"]);
  }

  private showRequestError(error: HttpErrorResponse) {
    this.requestErrorMessage = error?.error?.errors?.[0] ?? DEFAULT_ERROR_MESSAGE;
    this.isRequestError = true;
  }

  ngOnInit(): void {
    this.form = new UntypedFormGroup({
      email: new UntypedFormControl("", [Validators.required, Validators.email]),
    });
  }
}
